import HowWorkBG from '@/assets/website/how_work_bg.svg';
import Work1 from '@/assets/website/work1.png';
import Work2 from '@/assets/website/work2.png';
import Work3 from '@/assets/website/work3.png';

export default function HowVitaeWork() {
  return (
    <div className="relative mt-12 w-full">
      <img
        className="min-h-[1700px] w-full object-cover md:min-h-[1100px]"
        src={HowWorkBG}
      />
      <div className="absolute left-1/2 top-1/2 w-full translate-x-[-50%] translate-y-[-50%] text-sm">
        <div className="mx-4 mt-12 items-center justify-center text-center text-lg">
          <p className="mt-12 mb-14 text-center text-3xl font-bold text-[#4e4e4e]">
            How Vitae Works?
          </p>
          <div className="items-center justify-center lg:mx-32">
            <WorkCard
              indexString="01"
              title="Create Org Space"
              desc="Create a Vitae Space for your org, and complete information to let the world know about your org"
              src={Work1}
            />
            <WorkCard
              indexString="02"
              title="Send Vitae to members"
              desc="Create or choose previous Identity or Experience Vitae and fill out the allowlist wallet address."
              src={Work2}
            />
            <WorkCard
              indexString="03"
              title="Members claim the Vitae"
              desc="Copy the Vitae claiming link and send it to your community, eligible members can claim it."
              src={Work3}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  indexString: string;
  title: string;
  desc: string;
  src: string;
}

function WorkCard(props: Props) {
  return (
    <div
      className="w-3xl mx-6 my-14 min-w-[180px] max-w-[1600px] rounded-[62px] border-2 border-white bg-white/40 p-12 md:flex"
      style={{ boxShadow: '0px 2px 10px 0 #ecf4ee' }}
    >
      <div>
        <div className="items-center text-left md:flex">
          <p
            className="md:mr-8"
            style={{
              fontSize: 70,
              fontWeight: '700',
              lineHeight: '100%',
              background:
                'linear-gradient(159deg, rgba(193.50, 247.56, 79.43, 1), rgba(92.05, 240.12, 222.36, 1))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {props.indexString}
          </p>
          <p className="w-4/5 text-left align-bottom text-2xl font-bold text-[#4e4e4e]">
            {props.title}
          </p>
        </div>
        <p className="mt-3 max-w-lg text-left text-lg text-[#4e4e4e]">
          {props.desc}
        </p>
      </div>
      <div className="w-4 grow"></div>
      <img
        className="mt-6 w-3/5 min-w-[180px] max-w-[240px] object-scale-down"
        src={props.src}
      />
    </div>
  );
}
